import React from "react";
import { connect } from "react-redux";
import { getCountry } from "../../../Slice/country.slice";
import endpoint from "../../../config/endpoints";
import RTTable from "../../../components/Comman/RT/RTTable";
import { Paper } from "@mui/material";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { getSalesExecutiveByUserType } from "../../../Slice/salesExecutive.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { ClaimAnalysisJson } from "../../../DynamicFormsJson/MastersJSON/ClaimAnalysis";
import { getClaimApplyListBySalesTeamAndFlag } from "../../../Slice/claim.slice";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import ClaimAnalysisPopUp from "./ClaimAnalysisPopUp";
import { apiGet } from "../../../utils/api_service";
import { downloadF } from "../../PDF/PDFDownload";
class ClaimAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
      },
      searchValue: "",
      viewPopup: false,
      viewData: {},
      DataToSet: [],
      fixedCalculation: "",
      formData: { type: "0" },
      claimApplyDetails: [],
      salesTeamId: "",
      fromDate: "",
      toDate: "",
      type: "",
    };
  }

  componentDidMount() {
    const { getSalesExecutiveByUserType, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
        ({ success, response }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.salesPersonList !== nextProps.salesPersonList) {
      if (
        this.props.salesPersonList?.salesPersonByArea !==
        nextProps.salesPersonList?.salesPersonByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
          },
        });
      }
    }
  }

  onSearch = (data) => {
    const {
      getClaimApplyListBySalesTeamAndFlag,
      showLoador,
      showNotification,
    } = this.props;

    this.setState({
      salesTeamId: data?.salesTeamIds,
      fromDate: data?.fromDate,
      toDate: data?.toDate,
      type: data?.type,
    });

    if (navigator.onLine) {
      showLoador({ loador: true });
      getClaimApplyListBySalesTeamAndFlag({
        salesTeamId: data?.salesTeamIds,
        fromDate: data?.fromDate,
        toDate: data?.toDate,
        type: data?.type,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else if (!response || response.length === 0) {
          showNotification({ msg: "Data Not Found", severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchInTable = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (claimList) => {
    const { searchValue } = this.state;
    return claimList.filter((currentRow) => {
      let isValid = false;
      let date = currentRow.date != null ? currentRow.date : "-";
      let dayName = currentRow.dayName != null ? currentRow.dayName : "-";
      let salesTeamEmployeeCode =
        currentRow.salesTeamEmployeeCode != null
          ? currentRow.salesTeamEmployeeCode
          : "-";
      let name = currentRow.name != null ? currentRow.name : "-";
      let authoritySalesPersonName =
        currentRow.authoritySalesPersonName != null
          ? currentRow.authoritySalesPersonName
          : "-";
      let claimTitle =
        currentRow.claimTitle != null ? currentRow.claimTitle : "-";
      let claimAmt = currentRow.claimAmt != null ? currentRow.claimAmt : "-";
      let status = currentRow.status != null ? currentRow.status : "-";
      let total = currentRow.total != null ? currentRow.total : "-";
      if (
        date &&
        date.toLowerCase().toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        dayName &&
        dayName
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        salesTeamEmployeeCode &&
        salesTeamEmployeeCode
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        name &&
        name.toLowerCase().toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        authoritySalesPersonName &&
        authoritySalesPersonName
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        claimTitle &&
        claimTitle
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        claimAmt &&
        claimAmt.toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        status &&
        status
          .toLowerCase()
          .toString()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
      if (
        total &&
        total.toString().includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }

      return isValid;
    });
  };

  rowView = (rowData) => {
    const { showLoador, showNotification } = this.props;
    let viewDataList = [];
    let claimApplyDetails = [];
    showLoador({ loador: true });
    apiGet({
      url: endpoint.claimApplyHeader + "/" + rowData.id,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        claimApplyDetails = data.data.claimApplyDetails.map(
          (dataObj, index) => {
            let dataJson = {
              index: index + 1,
              claimAmt:
                dataObj.claimAmt !== null ? dataObj.claimAmt.toFixed(2) : "",
              claimType:
                dataObj.claimType !== null && dataObj.claimType.name !== null
                  ? dataObj.claimType.name
                  : "",
              remark: dataObj.remark !== null ? dataObj.remark : "",
              attachFile: dataObj.attachFile !== null ? dataObj.attachFile : "",
              isFile: dataObj.attachFile !== null ? "1" : "0",
            };
            return dataJson;
          }
        );
        viewDataList.push(data.data);
        this.setState({
          DataToSet: [
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Date",
              value: data.data.date !== null ? data.data.date : "-",
            },
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Sales Team",
              value: data.data.salesTeam !== null
                && data.data.salesTeam.name !== null
                && data.data.salesTeam.stockStakeHolderType !== null
                && data.data.salesTeam.stockStakeHolderType.prefix !== null ?
                data.data.salesTeam.name + " (" + data.data.salesTeam.stockStakeHolderType.prefix + ")" : "-",
            },
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Claim Title",
              value: data.data.name !== null ? data.data.name : "-",
            },
            {
              xs: 12,
              sm: 4,
              md: 4,
              lg: 4,
              label: "Claim Amount",
              value: data.data.claimAmt !== null ? data.data.claimAmt.toFixed(2) : "-",
            },
          ],
          claimApplyDetails: claimApplyDetails,
          viewData: viewDataList,
          viewPopup: true,
        });
      }
    });
  };

  handleClosesCategory = () => {
    this.setState({
      viewPopup: false,
    });
  };

  generateExcel = () => {
    const { fromDate, toDate, salesTeamId, type } = this.state;
    const { showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: true,
        url:
          endpoint.exportData +
          "/claim-apply-list-by-sales-team-and-flag-excel?fromDate=" +
          fromDate +
          "&toDate=" +
          toDate +
          "&salesTeamId=" +
          salesTeamId +
          "&type=" +
          type,
        ext: "xls",
        openNewTab: false,
      }).then((response) => {
        if (!response) {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { claimList } = this.props;
    const {
      dynamicMasterData,
      salesPersonList,
      viewPopup,
      claimApplyDetails,
      viewData,
      DataToSet,
      fixedCalculation,
      formData,
    } = this.state;

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            callBeforeSave={true}
            callBeforeSaveMethod={this.callBeforeSaveMethod}
            formPath={ClaimAnalysisJson.formPath}
            showPdfDownload={false}
            showExcelDownload={false}
            showBackToList={false}
            dynamicMasterData={dynamicMasterData}
            getListById={this.getListById}
            screenTitle={ClaimAnalysisJson.screenTitle}
            fieldMeta={ClaimAnalysisJson.fieldMeta}
            apiBaseURL={ClaimAnalysisJson.apiBaseURL}
            showSaveNextBtn={ClaimAnalysisJson.showSaveNextBtn}
            isEditURL={ClaimAnalysisJson.isEditURL}
            showSaveBtnMain={false}
            showSaveBtn={true}
            onSave={this.onSearch}
            saveBtnText={"Search"}
            showCancel={false}
          />

          {claimList?.salesTeamClaimByFlag?.length > 0 && (
            <LandingScreenHeader
              screenTitle={""}
              showSearchBox={true}
              showTable={true}
              showFilter={false}
              showPdfDownload={false}
              showExcelDownload={true}
              generateExcel={this.generateExcel}
              onSearch={this.onSearchInTable}
            />
          )}

          {claimList?.salesTeamClaimByFlag?.length > 0 && (
            <RTTable
              showPegination={false}
              columns={[
                {
                  name: "index",
                  title: "Sr. No.",
                  align: "center",
                  width: "10%",
                },
                {
                  name: "date",
                  title: "Date",
                  align: "center",
                },
                {
                  name: "dayName",
                  title: "Day",
                  align: "left",
                },
                {
                  name: "salesTeamEmployeeCode",
                  title: "Employee Code",
                  align: "center",
                },
                {
                  name: "name",
                  title: "Claim From",
                  align: "left",
                },
                {
                  name: "authoritySalesPersonName",
                  title: "Claim To",
                  align: "left",
                },
                { name: "claimTitle", title: "Claim Title", align: "left" },
                { name: "claimAmt", title: "Claim Amount", align: "right" },
                { name: "status", title: "Status", align: "left" },
                { name: "total", title: "Action", align: "right" },
              ]}
              tableData={this.getFilteredTableData(
                claimList?.salesTeamClaimByFlag
              )}
              isActionColActive={true}
              showEditIcon={false}
              showDeleteIcon={false}
              showViewButtonInTable={true}
              rowView={this.rowView}
            />
          )}
        </Paper>
        {viewPopup && (
          <ClaimAnalysisPopUp
            open={viewPopup}
            handleCloses={this.handleClosesCategory}
            columns={[
              {
                title: "Sr. No.",
                name: "index",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                align: "center",
              },
              {
                title: "Claim Amount",
                name: "claimAmt",
                positionCenter: false,
                showInscreen: true,
                alignCell: "right",
                alignCenter: "right",
                canSearch: true,
              },
              {
                title: "Claim Type",
                name: "claimType",
                positionCenter: false,
                showInscreen: true,
                alignCell: "left",
                alignCenter: "left",
                canSearch: true,
              },
              {
                title: "Remark",
                name: "remark",
                positionCenter: false,
                showInscreen: true,
                alignCell: "left",
                alignCenter: "left",
                canSearch: true,
              },
              {
                title: "Attchment",
                name: "action",
                positionCenter: false,
                showInscreen: true,
                alignCell: "center",
                alignCenter: "center",
                canSearch: true,
              },
            ]}
            rows={claimApplyDetails}
            viewHeaderData={viewData}
            DataToSet={DataToSet}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
  claimList: state.claim,
});
const mapDispatchToProps = {
  getCountry,
  getSalesExecutiveByUserType,
  getClaimApplyListBySalesTeamAndFlag,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimAnalysis);
